import type { CartItem, DetailedSaleItem, PackageGroup, PackageItem } from '@src/domains/cart/types/cart';

export function groupItemsByPackageUnitId<T extends PackageItem>(items: T[]) {
  const individualItems: T[] = [];
  const packageItemsMap: { [key: string]: T[] } = {};
  const packageGroup: PackageGroup<T>[] = [];

  items.forEach((item) => {
    const unitId = item.productPackageUnitId;

    if (unitId) {
      if (!packageItemsMap[unitId]) {
        packageItemsMap[unitId] = [];
      }
      packageItemsMap[unitId].push(item);
    } else {
      individualItems.push(item);
    }
  });

  Object.values(packageItemsMap).forEach((packageItems) => {
    const productPackage = packageItems[0]!.productPackageProduct!.productPackage;

    const packageStructure = {
      productPackage: productPackage!,
      items: packageItems,
    };

    packageGroup.push(packageStructure);
  });

  return { individualItems, packageGroup };
}

export const groupCartItemsByPackageUnitId = (items: CartItem[]) => groupItemsByPackageUnitId(items);
export const groupSaleItemsByPackageUnitId = (items: DetailedSaleItem[]) => groupItemsByPackageUnitId(items);
